<!-- src/components/price_list_grid.html -->
<div class='container-fluid'>

  <b-row>
    <b-col cols="12">
     
      <b-table
        :items="prices_list_rows"
        :fields="prices_list_columns"
        :per-page="perPage"        
        @row-clicked="onRowClick"
      >
        <template #cell(checkboxes)="row">
          <input type="checkbox" v-model="row.item.checked" @change="onCheckboxChange(row.item)" />
          <!-- <b-form-checkbox v-model="row.item.checked" @change="onCheckboxChange(row.item)"></b-form-checkbox> -->
        </template>
        <template #cell(id)="data">
          <span v-if="false" :key="data.item.id">{{ data.item.id }}</span>
        </template>     

        <template #cell(start_date)="data">
          <span v-if="data.item.start_date">
            {{ data.item.start_date }}
          </span>

        </template>     

        <template #table-caption>
          Listini (Pagina {{ currentPage }} di {{ totalPages }})
        </template>
      </b-table>

    </b-col>
  </b-row>
  <b-row class="mb-3">
    <b-col cols="12">
      <b-pagination
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
        @update:modelValue="onPageChange"
      >        
      </b-pagination>
    </b-col>
  </b-row>

</div>